import React, { type SVGProps } from "react";
import { illustrationSizes, type IllustrationProps } from "./utils/shared";
const NoData = (props: SVGProps<SVGSVGElement> & IllustrationProps) => (
  <svg
    width={props.size ? illustrationSizes[props.size] : illustrationSizes["s"]}
    height={props.size ? illustrationSizes[props.size] : illustrationSizes["s"]}
    viewBox="0 0 335 335"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    title="NoData"
    color="transparent"
    {...props}
  >
    <path
      opacity={0.18}
      d="M195.109 51.0227C173.463 57.4305 156.909 72.7618 137.167 82.9584C113.523 95.1116 85.4513 99.6458 62.695 113.052C38.9106 127.058 22.9765 149.791 14.2151 173.869C6.70362 194.573 4.12193 217.223 11.0142 238.051C17.9066 258.879 35.2425 277.689 58.5362 284.573C82.4724 291.643 108.465 285.732 133.674 284.801C168.147 283.517 203.076 291.695 236.919 285.743C265.375 280.62 290.505 265.97 307.08 244.842C311.4 239.572 314.635 233.667 316.636 227.399C318.809 219.853 318.353 211.944 318.692 204.159C319.498 185.194 325.105 166.612 326.636 147.679C327.804 133.331 326.402 117.958 318.902 104.956C310.269 89.9667 294.721 83.9833 280.247 74.387C254.874 57.5341 228.812 41.0538 195.109 51.0227Z"
      fill="#CFDAFF"
    />
    <circle cx={69} cy={216} r={20} fill="white" />
    <path
      d="M68.4754 204C72.9508 204 76 206.545 76 210.752C76 215.3 72.6557 217.304 68.1311 217.304L67.9934 219.859H64.6885L64.5213 214.788H65.6229C69.4 214.788 72.3115 214.142 72.3115 210.752C72.3544 210.256 72.2839 209.758 72.1049 209.291C71.9259 208.825 71.6429 208.403 71.2759 208.054C70.9089 207.705 70.4669 207.438 69.9812 207.273C69.4956 207.107 68.9781 207.047 68.4656 207.096C66.0852 207.096 64.5803 208.387 64.5803 210.647H61C61.0098 206.744 63.9213 204 68.4754 204ZM66.3311 227C65.8451 227.007 65.3678 226.875 64.9599 226.62C64.552 226.365 64.232 225.998 64.0405 225.567C63.8491 225.135 63.795 224.659 63.885 224.198C63.975 223.736 64.2051 223.312 64.546 222.977C64.8869 222.643 65.3232 222.414 65.7993 222.319C66.2755 222.225 66.7699 222.269 67.2197 222.447C67.6696 222.625 68.0544 222.928 68.3253 223.318C68.5962 223.707 68.7409 224.166 68.741 224.635C68.7462 224.944 68.6877 225.25 68.569 225.537C68.4502 225.824 68.2735 226.085 68.0492 226.305C67.8249 226.525 67.5575 226.7 67.2625 226.819C66.9676 226.938 66.6509 227 66.3311 227Z"
      fill="#4E72EA"
    />
    <circle cx={278.5} cy={176.5} r={29.5} fill="white" />
    <path
      d="M278.964 159C285.528 159 290 162.762 290 168.981C290 175.705 285.095 178.667 278.459 178.667L278.257 182.443H273.41L273.165 174.947H274.78C280.32 174.947 284.59 173.992 284.59 168.981C284.653 168.248 284.55 167.511 284.287 166.822C284.025 166.133 283.61 165.508 283.071 164.992C282.533 164.477 281.885 164.082 281.172 163.838C280.46 163.593 279.701 163.504 278.95 163.576C275.458 163.576 273.251 165.485 273.251 168.826H268C268.014 163.057 272.285 159 278.964 159ZM275.819 193C275.106 193.011 274.406 192.815 273.808 192.438C273.21 192.061 272.74 191.519 272.459 190.881C272.179 190.244 272.099 189.539 272.231 188.857C272.363 188.176 272.701 187.548 273.201 187.053C273.701 186.559 274.341 186.22 275.039 186.081C275.737 185.941 276.463 186.007 277.122 186.27C277.782 186.533 278.346 186.981 278.744 187.556C279.141 188.132 279.353 188.81 279.353 189.504C279.361 189.96 279.275 190.414 279.101 190.838C278.927 191.261 278.668 191.647 278.339 191.972C278.01 192.298 277.618 192.556 277.185 192.732C276.752 192.909 276.288 193 275.819 193Z"
      fill="#4E72EA"
    />
    <circle cx={166.5} cy={104.5} r={11.5} fill="white" />
    <path
      d="M165.987 98C168.374 98 170 99.4385 170 101.816C170 104.387 168.216 105.52 165.803 105.52L165.73 106.964H163.967L163.878 104.097H164.466C166.48 104.097 168.033 103.732 168.033 101.816C168.056 101.536 168.018 101.254 167.923 100.991C167.827 100.727 167.676 100.488 167.48 100.291C167.285 100.094 167.049 99.9433 166.79 99.8497C166.531 99.7561 166.255 99.722 165.982 99.7498C164.712 99.7498 163.91 100.48 163.91 101.757H162C162.005 99.5512 163.558 98 165.987 98ZM164.843 111C164.584 111.004 164.329 110.929 164.112 110.785C163.894 110.641 163.724 110.434 163.622 110.19C163.52 109.946 163.491 109.677 163.539 109.416C163.587 109.155 163.709 108.915 163.891 108.726C164.073 108.537 164.306 108.408 164.56 108.354C164.814 108.301 165.077 108.326 165.317 108.427C165.557 108.527 165.762 108.698 165.907 108.919C166.051 109.139 166.128 109.398 166.129 109.663C166.131 109.838 166.1 110.011 166.037 110.173C165.973 110.335 165.879 110.483 165.76 110.607C165.64 110.732 165.497 110.83 165.34 110.898C165.183 110.965 165.014 111 164.843 111Z"
      fill="#4E72EA"
    />
    <circle cx={178.826} cy={197.826} r={57.8261} fill="#4E72EA" />
    <circle cx={178.826} cy={197.826} r={51.6082} fill="white" />
    <path
      d="M150.801 225.808C128.415 204.044 140.229 156.841 181.888 158.653C214.221 160.06 231.631 200.935 206.762 225.808"
      stroke="#B1C3FF"
      strokeLinecap="round"
      fill="none"
    />
    <rect
      x={135.301}
      y={204.277}
      width={4.97429}
      height={1.24357}
      rx={0.621786}
      transform="rotate(-9.89077 135.301 204.277)"
      fill="#B1C3FF"
    />
    <rect
      x={137.166}
      y={212.591}
      width={4.97429}
      height={1.24357}
      rx={0.621786}
      transform="rotate(-20.0622 137.166 212.591)"
      fill="#B1C3FF"
    />
    <rect
      x={140.355}
      y={219.228}
      width={4.97429}
      height={1.24357}
      rx={0.621786}
      transform="rotate(-29.6342 140.355 219.228)"
      fill="#B1C3FF"
    />
    <rect
      x={144.628}
      y={226.507}
      width={4.97429}
      height={1.24357}
      rx={0.621786}
      transform="rotate(-39.8457 144.628 226.507)"
      fill="#B1C3FF"
    />
    <rect x={134.679} y={197.204} width={4.97429} height={1.24357} rx={0.621786} fill="#B1C3FF" />
    <rect
      x={135.509}
      y={189.743}
      width={4.97429}
      height={1.24357}
      rx={0.621786}
      transform="rotate(9.67562 135.509 189.743)"
      fill="#B1C3FF"
    />
    <rect
      x={138.23}
      y={181.862}
      width={4.97429}
      height={1.24357}
      rx={0.621786}
      transform="rotate(20.4206 138.23 181.862)"
      fill="#B1C3FF"
    />
    <rect
      x={141.518}
      y={174.82}
      width={4.97429}
      height={1.24357}
      rx={0.621786}
      transform="rotate(30.0133 141.518 174.82)"
      fill="#B1C3FF"
    />
    <rect
      x={144.877}
      y={169.726}
      width={4.97429}
      height={1.24357}
      rx={0.621786}
      transform="rotate(39.6895 144.877 169.726)"
      fill="#B1C3FF"
    />
    <rect
      x={151.186}
      y={163.628}
      width={4.97429}
      height={1.24357}
      rx={0.621786}
      transform="rotate(50.7554 151.186 163.628)"
      fill="#B1C3FF"
    />
    <rect
      x={157.515}
      y={158.653}
      width={4.97429}
      height={1.24357}
      rx={0.621786}
      transform="rotate(59.6661 157.515 158.653)"
      fill="#B1C3FF"
    />
    <rect
      x={165.068}
      y={156.167}
      width={4.97429}
      height={1.24357}
      rx={0.621786}
      transform="rotate(69.529 165.068 156.167)"
      fill="#B1C3FF"
    />
    <rect
      x={172.592}
      y={154.923}
      width={4.37188}
      height={1.24357}
      rx={0.621786}
      transform="rotate(80.8292 172.592 154.923)"
      fill="#B1C3FF"
    />
    <rect
      width={4.37188}
      height={1.24357}
      rx={0.621786}
      transform="matrix(0.00284334 0.999996 -0.999996 0.00289093 180.069 154.302)"
      fill="#B1C3FF"
    />
    <rect
      x={187.973}
      y={155.099}
      width={4.37188}
      height={1.24357}
      rx={0.621786}
      transform="rotate(101.878 187.973 155.099)"
      fill="#B1C3FF"
    />
    <rect
      x={194.864}
      y={156.57}
      width={4.37188}
      height={1.24357}
      rx={0.621786}
      transform="rotate(109.03 194.864 156.57)"
      fill="#B1C3FF"
    />
    <rect
      x={202.022}
      y={160.581}
      width={4.37188}
      height={1.24357}
      rx={0.621786}
      transform="rotate(121.93 202.022 160.581)"
      fill="#B1C3FF"
    />
    <rect
      x={207.501}
      y={164.403}
      width={4.37188}
      height={1.24357}
      rx={0.621786}
      transform="rotate(130.167 207.501 164.403)"
      fill="#B1C3FF"
    />
    <rect
      x={212.748}
      y={169.525}
      width={4.37188}
      height={1.24357}
      rx={0.621786}
      transform="rotate(137.865 212.748 169.525)"
      fill="#B1C3FF"
    />
    <rect
      x={217.479}
      y={175.925}
      width={4.84855}
      height={1.24357}
      rx={0.621786}
      transform="rotate(152.633 217.479 175.925)"
      fill="#B1C3FF"
    />
    <rect
      x={220.67}
      y={183.455}
      width={4.37188}
      height={1.24357}
      rx={0.621786}
      transform="rotate(160.675 220.67 183.455)"
      fill="#B1C3FF"
    />
    <rect
      x={223.145}
      y={190.966}
      width={5.11069}
      height={1.24357}
      rx={0.621786}
      transform="rotate(169.492 223.145 190.966)"
      fill="#B1C3FF"
    />
    <rect
      x={223.594}
      y={198.448}
      width={4.97296}
      height={1.24357}
      rx={0.621786}
      transform="rotate(179.103 223.594 198.448)"
      fill="#B1C3FF"
    />
    <rect
      x={222.819}
      y={206.394}
      width={4.98919}
      height={1.24357}
      rx={0.621786}
      transform="rotate(-167.707 222.819 206.394)"
      fill="#B1C3FF"
    />
    <rect
      x={220.212}
      y={213.617}
      width={4.91582}
      height={1.24357}
      rx={0.621786}
      transform="rotate(-158.901 220.212 213.617)"
      fill="#B1C3FF"
    />
    <rect
      x={217.289}
      y={220.624}
      width={4.91582}
      height={1.24357}
      rx={0.621786}
      transform="rotate(-150.193 217.289 220.624)"
      fill="#B1C3FF"
    />
    <rect
      x={212.127}
      y={226.893}
      width={4.71917}
      height={1.24357}
      rx={0.621786}
      transform="rotate(-139.979 212.127 226.893)"
      fill="#B1C3FF"
    />
    <path
      d="M179.574 193.735C174.603 193.911 173.906 197.669 174.18 199.526L172.981 200.813L162.616 206.78C163.501 214.215 169.737 214.616 170.98 214.571C171.974 214.536 175.043 206.339 176.819 203.787L178.018 202.5C182.475 201.845 183.057 198.381 182.791 196.732L210.939 165.869L210.295 165.269L179.574 193.735Z"
      fill="#4E72EA"
    />
    <ellipse
      cx={179.084}
      cy={197.487}
      rx={4.97428}
      ry={4.97428}
      transform="rotate(-2.03146 179.084 197.487)"
      fill="#4E72EA"
    />
    <ellipse
      cx={179.085}
      cy={197.486}
      rx={2.48714}
      ry={2.48714}
      transform="rotate(-2.03146 179.085 197.486)"
      fill="white"
    />
  </svg>
);
export default React.memo(NoData);
